import React, { useEffect } from "react";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetUserPreferences, useUpdateUserPreferences } from "@api";

import { Button, Text } from "@ui/elements";
import { Checkbox } from "@ui/forms";
import { Stack } from "@ui/layout";

import { toaster } from "@components";

type BetaFeaturesFormValues = {
  allowValueBasedV2: boolean;
};

export const BetaFeatures = () => {
  const { t } = useTranslation();
  const { data: userPreferenceData } = useGetUserPreferences();
  const { register, handleSubmit, setValue } = useForm<BetaFeaturesFormValues>({
    defaultValues: {
      allowValueBasedV2: !!userPreferenceData?.allowValueBasedV2,
    },
  });

  useEffect(() => {
    if (userPreferenceData) {
      setValue(
        "allowValueBasedV2",
        userPreferenceData?.allowValueBasedV2 || false,
      );
    }
  }, [userPreferenceData]);

  const { mutateAsync, isPending } = useUpdateUserPreferences();

  const onSubmit = async (values: BetaFeaturesFormValues) => {
    await mutateAsync({
      data: values,
    });

    toaster.success({
      title: t("messages.successful-update"),
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="column" gap="xl">
        <Text variant="secondary">{t("beta-features-info")}</Text>
        <Checkbox isCentered={false} {...register("allowValueBasedV2")}>
          <Text weight="bold">{t("tip-type.value-based-v2")}</Text>
          <Text variant="secondary">{t("value-based-desc")}</Text>
        </Checkbox>
        <Stack justify="end">
          <Button variant="light" isLoading={isPending}>
            {t("labels.save")}
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
